import { getDateInFormat } from "@domains/utils/reportDates";
export const CircularUpdate = (data) => {
    const result = {
        circular: [],
    };
    if (data && data.crclrs) {
        result.circular = mapCircularUpdates(data.crclrs);
    }
    return result;
};
const mapCircularUpdates = (list) => {
    return list.map((item) => {
        return {
            circularID: item.circularID,
            circularNumber: item.circularNum,
            exchange: item.exchange,
            pdfPath: item.pdfPath,
            pdfReportName: item.pdfReportName,
            publishDate: getDateInFormat(item.publishDate, "MMM DD, YYYY"),
            title: item.title,
            extension: item.pdfPath ? item.pdfPath.split(".").pop() : "",
            isActive: item.isActive,
        };
    });
};
